import { render } from "./WheelFilterForm.vue?vue&type=template&id=53e146c4&scoped=true"
import script from "./WheelFilterForm.vue?vue&type=script&lang=js"
export * from "./WheelFilterForm.vue?vue&type=script&lang=js"

import "./WheelFilterForm.vue?vue&type=style&index=0&id=53e146c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e146c4"]])

export default __exports__